import React from "react";
import PageNotFound from "../Pages/NotFound";
import { mainNav } from "../Components/Common/Navbar";
import ForgotPassword from "../Pages/Login/ForgotPassword";
import ResetPassword from "../Pages/Login/ResetPassword";
import Login from "../Pages/Login";
import Logout from "../Pages/Login/Logout";
import PrivacyPolicy from "../Pages/PrivacyPolicy";

const PublicRoutes = [
  {
    path: "/",
    index: false,
    element: <Login isMainNav={true} />,
  },

  {
    path: "/forgot-password",
    index: false,
    element: <ForgotPassword navigationBar={mainNav} isMainNav={true} />,
  },
  {
    path: "/reset-password/:token",
    index: false,
    element: <ResetPassword navigationBar={mainNav} isMainNav={true} />,
  },
  {
    path: "/logout",
    index: false,
    element: <Logout navigationBar={mainNav} isMainNav={true} />,
  },
  {
    path: "/privacy-policy",
    index: false,
    element: <PrivacyPolicy type={"privacy"} />,
  },
  {
    path: "/t&c",
    index: false,
    element: <PrivacyPolicy type={"terms"} />,
  },
  { path: "*", element: <PageNotFound /> },
];

export default PublicRoutes;
